var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProjectPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 21C21 19.3 22.3 18 24 18C25.7 18 27 19.3 27 21C27 22.7 25.7 24 24 24C22.3 24 21 22.7 21 21ZM24 26C19.4 26 18 29.3 18 29.3V31H30V29.3C30 29.3 28.6 26 24 26Z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 23C31.8807 23 33 21.8807 33 20.5C33 19.1193 31.8807 18 30.5 18C29.1193 18 28 19.1193 28 20.5C28 21.8807 29.1193 23 30.5 23Z",
    fill: "#4F4F4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 25C29.3 25 28.4 25.3 27.7 25.8C30 26.9 30.9 28.8 30.9 29V29.1H35V27.8C35 27.7 33.9 25 30.5 25Z",
    fill: "#4F4F4F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 23C31.8807 23 33 21.8807 33 20.5C33 19.1193 31.8807 18 30.5 18C29.1193 18 28 19.1193 28 20.5C28 21.8807 29.1193 23 30.5 23Z",
    fill: "#4F4F4F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 25C29.3 25 28.4 25.3 27.7 25.8C30 26.9 30.9 28.8 30.9 29V29.1H35V27.8C35 27.7 33.9 25 30.5 25Z",
    fill: "#4F4F4F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 23C18.8807 23 20 21.8807 20 20.5C20 19.1193 18.8807 18 17.5 18C16.1193 18 15 19.1193 15 20.5C15 21.8807 16.1193 23 17.5 23Z",
    fill: "#4F4F4F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 25C18.7 25 19.6 25.3 20.3 25.8C18 26.9 17.1 28.8 17.1 29V29.1H13V27.8C13 27.7 14.1 25 17.5 25Z",
    fill: "#4F4F4F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectPlaceholder);
export default __webpack_public_path__ + "static/media/ProjectPlaceholder.4224b1d8645af5053465c412b73a25a0.svg";
export { ForwardRef as ReactComponent };